module.exports = __webpack_public_path__ + "img/placeholder-image.8865f01b.jpg";